if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  // ----------------------------
  // CARE ADDON DETECTION
  // ----------------------------
  const addonWrap = this.querySelector('[data-care-addon]');
  const addonCheckbox = addonWrap ? addonWrap.querySelector('.care-addon__checkbox') : null;
  const addonVariantId = addonWrap ? addonWrap.getAttribute('data-addon-variant-id') : null;
  const addonUnavailable = addonWrap ? addonWrap.getAttribute('data-addon-unavailable') === 'true' : false;

  const shouldAddAddon =
    addonCheckbox &&
    addonCheckbox.checked &&
    addonVariantId &&
    !addonUnavailable;

  // Base form data for MAIN item (Dawn default)
  const formData = new FormData(this.form);
  const mainVariantId = formData.get('id');

  // Sections (Dawn)
  const sectionsArray = this.cart
    ? this.cart.getSectionsToRender().map((section) => section.id)
    : [];

  if (this.cart) {
    formData.append('sections', sectionsArray);
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  const isCartNotification = this.cart && this.cart.tagName.toLowerCase() === 'cart-notification';

  // Helper to safely replace section HTML by id (used for silent addon update)
  const replaceSectionById = (htmlString, id) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const newEl = doc.getElementById(id);
    const curEl = document.getElementById(id);
    if (newEl && curEl) curEl.innerHTML = newEl.innerHTML;
  };

  // 1) ADD MAIN PRODUCT (normal Dawn flow)
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: mainVariantId,
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

       const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
if (!soldOutMessage) return;

this.submitButton.setAttribute('aria-disabled', true);

const buttonText = this.submitButton.querySelector('span');

if (buttonText) {
  buttonText.textContent = 'in your bag ♡';
}

this.error = true;
return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      // Update notification/drawer for MAIN product (this is what makes popup show item)
      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainVariantId, cartData: response });
      }
   this.error = false;

if (this.submitButton && !this.closest('quick-add-modal')) {
  const buttonText = this.submitButton.querySelector('span');
  if (buttonText) buttonText.textContent = 'in your bag ♡';
  this.submitButton.setAttribute('aria-disabled', true);
}

const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }

      // 2) SILENTLY ADD ADDON (so popup remains correct)
      if (shouldAddAddon) {
        try {
          const addonFd = new FormData();
          addonFd.append('id', addonVariantId);
          addonFd.append('quantity', 1);

          // For cart icon + button to update after addon add
          // (Notification product block is based on "key", we don't need to re-render it)
          const addonSections = isCartNotification
            ? ['cart-notification-button', 'cart-icon-bubble']
            : sectionsArray;

          if (addonSections.length) {
            addonFd.append('sections', addonSections);
            addonFd.append('sections_url', window.location.pathname);
          }

          const addonConfig = fetchConfig('javascript');
          addonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete addonConfig.headers['Content-Type'];
          addonConfig.body = addonFd;

          const addonRes = await fetch(`${routes.cart_add_url}`, addonConfig);
          const addonJson = await addonRes.json();

          // If drawer: re-render fully (drawer can handle it)
          if (this.cart && !isCartNotification) {
            this.cart.renderContents(addonJson);
          }

          // If notification: only refresh the button + cart bubble so totals/count reflect addon
          if (this.cart && isCartNotification && addonJson.sections) {
            if (addonJson.sections['cart-notification-button']) {
              // cart-notification-button section contains element with id cart-notification-button
              replaceSectionById(addonJson.sections['cart-notification-button'], 'cart-notification-button');
            }
            if (addonJson.sections['cart-icon-bubble']) {
              replaceSectionById(addonJson.sections['cart-icon-bubble'], 'cart-icon-bubble');
            }
          }

          // Optional: uncheck after successful add
          addonCheckbox.checked = false;
        } catch (e) {
          console.error('Addon add failed:', e);
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
